export interface UploadValidationOptions {
    allowedContentTypes?: string[];
}

export interface UploadValidationResult {
    valid: boolean;
    error?: string;
}

export function validateUploadFile(file: File, options: UploadValidationOptions = {}): UploadValidationResult {
    if (!file) {
        return { valid: false, error: 'Selecione um arquivo para upload.' };
    }

    if (file.size <= 0 && !isOutlookMessage(file)) {
        return { valid: false, error: `O arquivo ${file.name} está vazio.` };
    }

    if (options.allowedContentTypes && options.allowedContentTypes.length > 0 && !options.allowedContentTypes.includes(file.type)) {
        return { valid: false, error: `O tipo do arquivo ${file.name} não é permitido.` };
    }

    return { valid: true };
}

function isOutlookMessage(file: File): boolean {
    return !!file.name && file.name.toLowerCase().endsWith('.msg');
}
